export enum FormattedLabelEnum {
  AppointmentLine1 = '00000267-1000-0000-0000-000000000001',
  AppointmentLine2 = '00000267-1000-0000-0000-000000000002',
  AppointmentDetails = '00000267-1000-0000-0000-000000000003',
  Appointment15Min = '00000267-1000-0000-0000-000000000004',
  IOImageLabel = '00000267-1000-0000-0000-000000000005',
  IOImageTooltip = '00000267-1000-0000-0000-000000000006',
  ImageStamp = '00000267-1000-0000-0000-000000000007',
  IOLectureLabel = '00000267-1000-0000-0000-000000000008',
  IOLectureTooltip = '00000267-1000-0000-0000-000000000009',
}
